import { computed, inject, Signal } from '@angular/core';
import { Contract } from '@models/contract';
import { InsuranceType, isInsuranceType } from '@models/insurance-type';
import { Product } from '@models/product';
import { ProductsService } from 'app/products/products.service';

export function getCanonicalProduct(insuranceType: Signal<InsuranceType>): Signal<Product>;
export function getCanonicalProduct(contract: Signal<Contract>): Signal<Product>;
export function getCanonicalProduct(inputSignal: Signal<Contract> | Signal<InsuranceType>): Signal<Product> {
    const productsService = inject(ProductsService);

    return computed(() => {
        const inputValue = inputSignal();

        if (!inputValue) {
            return null;
        }

        let insuranceType: InsuranceType;

        if (isInsuranceType(inputValue)) {
            insuranceType = inputValue;
        } else {
            insuranceType = inputValue.insuranceType;
        }

        return productsService.getCanonicalByInsuranceType(insuranceType);
    });
}
